import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Checkbox,
  DatePicker,
  Input,
  notification,
  Radio,
  Row,
  Table,
} from "antd";
import dayjs from "dayjs";
import axios from "axios";
import {
  GetActiveEmployeesApi,
  GetSingleEmployeeData,
} from "../../../Services/CommonApis";
import {
  Date4,
  Select4,
  Text4,
} from "../../../Components/FormComponents/InputFields";
import { Controller, useForm } from "react-hook-form";

import CustomEditableTable from "./Component/IdentityTable";
import {
  getEmploymentAdditionalColumnsConfig,
  getColumnsConfig,
  getReferenceColumn,
  getEmploymentDocumentColumnsConfig,
} from "./Component/ComlumnConfig";
import {
  submitHistoryApi,
  submitJobDetailApi,
  submitIdentityDetail,
  submitEsicDetailApi,
  submitPfDetailApi,
  submitRefferenceApi,
} from "../../../api/IndentityApi";
import { useNavigate, useOutletContext } from "react-router-dom";
import CustomEditableCard from "./Component/IdentityTable";
import { MdKeyboardArrowDown } from "react-icons/md";
import { Trash2Icon } from "lucide-react";

const defaultRelations = [{ label: 1 }];
const RefreshCount = [{ label: 1 }];
const RelativeCount = [{ label: 1 }];

const formatLabel = (str) => {
  if (!str || typeof str !== "string") return str;
  return str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

// Employees that must not be selectable as a relative
const EXCLUDED_RELATIVE_EMPLOYEES = ["DJTCO0001"];

const employeeLabel = (emp) =>
  `${emp.name?.full_name || `${emp.name?.first_name || ""} ${emp.name?.last_name || ""}`.trim() || emp.employee_id} (${emp.employee_id})`;

const defaultValues = {
  aadhar_number: "",
  pan_number: "",
  voter_id: "",
  passport_number: "",
  driving_license: "",
  department: "",
  designation: "",
  employee_id: "",
  location: "",
  work_location: "",
  date_of_joining: "",
  employee_type: "",
  reporting_manager_id: "",
  esic_number: "",
  dispensary_address: "",
  uan_number: "",
  pf_number: "",
  is_covered: "",
  pf_transfer_required: null,
};

export default function IdentityDetail() {
  const navigate = useNavigate();
  const { responseData, id, profileData, dropDowns } = useOutletContext();
  const [tableData, setTableData] = useState(defaultRelations);
  const [tableData2, setTableData2] = useState(RefreshCount);
  const [relativeTableData, setRelativeTableData] = useState(RelativeCount);
  const [relativeOutput, setRelativeOutput] = useState(null);
  const [hasRelative, setHasRelative] = useState(null);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [experienceLevel, setExperienceLevel] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [output, setOutput] = useState(null);
  const [disableFields, setDisabledFields] = useState("");

  const [isEsic, setisEsic] = useState(false);
  const [reffrenceOutput, setRefferenceOutput] = useState(null);
  const [api, contextHolder] = notification.useNotification();
  const {
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors, isValid },
    setValue,
    getValues,
  } = useForm({
    defaultValues,
    mode: "onChange",
  });

  const isPanVerified = responseData?.pan_verified === true;

  const handleChangeValue = (value, field, relation) => {
    console.log(value, field, relation);
    if (field === "currently_working_here" && value === true) {
      setValue(`to_date_${relation}`, "", {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
    setOutput((prev) => ({
      ...prev,
      [relation]: {
        ...prev?.[relation],
        [field]: value,
        ...(field === "currently_working_here" && value === true
          ? {
            to_date: "",
            relieving_letter: null,
            experience_letter: null,
          }
          : {}),
        ...(field === "currently_working_here" && value === false
          ? { offer_letter: null, resignation_acceptance_letter: null }
          : {}),
      },
    }));
  };

  console.log(output);

  const handleChangeRefference = (value, field, relation) => {
    setRefferenceOutput((prev) => ({
      ...prev,
      [relation]: {
        ...prev?.[relation],
        [field]: value,
      },
    }));
  };

  const handleChangeRelative = (value, field, relation) => {
    setRelativeOutput((prev) => ({
      ...prev,
      [relation]: {
        ...prev?.[relation],
        [field]: value,
      },
    }));
  };

  const relationshipdrop =
    dropDowns?.RELATIONSHIP?.map((item) => {
      const val = typeof item === "object" ? item.value : item;
      return { label: formatLabel(val), value: val };
    }) || [];

  const ReferenceColumn = getReferenceColumn(handleChangeRefference);

  const columnsConfig = getColumnsConfig(handleChangeValue);
  const additionalColumnsConfig =
    getEmploymentAdditionalColumnsConfig(handleChangeValue);
  const documentColumnsConfig =
    getEmploymentDocumentColumnsConfig(handleChangeValue);

  const counter = useRef(0);

  function generateSimpleId() {
    return (
      "id-" +
      (counter.current++).toString(36) +
      "-" +
      Math.random().toString(36).slice(2, 5)
    );
  }

  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleAddRow = () => {
    setTableData((prev) => [
      ...prev,
      {
        label: generateSimpleId(),
      },
    ]);
  };
  const counter1 = useRef(0);

  function generateSimpleId1() {
    return (
      "id-" +
      (counter1.current++).toString(36) +
      "-" +
      Math.random().toString(36).slice(2, 5)
    );
  }

  const handleRemoveRow = (labelToRemove) => {
    setTableData((prev) => prev.filter((row) => row.label !== labelToRemove));
  };
  const handleRemoveRow2 = (labelToRemove) => {
    setTableData2((prev) => prev.filter((row) => row.label !== labelToRemove));
  };

  const handleAddRelativeRow = () => {
    setRelativeTableData((prev) => [...prev, { label: generateSimpleId1() }]);
  };
  const handleRemoveRelativeRow = (labelToRemove) => {
    setRelativeTableData((prev) =>
      prev.filter((row) => row.label !== labelToRemove),
    );
    setRelativeOutput((prev) => {
      const updated = { ...prev };
      delete updated[labelToRemove];
      return updated;
    });
  };

  const handleAddRow2 = () => {
    setTableData2((prev) => [
      ...prev,
      {
        label: generateSimpleId1(),
      },
    ]);
  };

  const onerror = (error) => {
    console.log(error);
  };

  const handleSubmittingFun = async (apiHitFun) => {
    try {
      setIsLoading(true);
      const { data } = await apiHitFun();
      setIsLoading(false);

      const message = data?.message?.toLowerCase() || "";

      const isAcceptableMessage =
        message.includes("already updated") ||
        message.includes("no changes made");
      if (isAcceptableMessage) {
        return true;
      }
      if (data.success) {
        api.success({ message: data.message, placement: "top" });
        return true;
      } else {
        api.error({ message: data.message, placement: "top" });
        return false;
      }
    } catch (e) {
      api.error({ message: "Something went wrong", placement: "top" });
      return false;
    }
  };

  const getEmploymentHistoryPayload = () => {
    if (experienceLevel === "fresher") {
      return { is_fresher: "true" };
    }

    const historyItems = Object.values(output || {});

    // Remove URLs (strings) from document fields to avoid sending them in the payload
    const cleanedItems = historyItems.map((item) => {
      const newItem = { ...item };
      const docFields = [
        "relieving_letter",
        "experience_letter",
        "offer_letter",
        "salary_slip",
        "resignation_acceptance_letter",
      ];

      docFields.forEach((field) => {
        if (typeof newItem[field] === "string") {
          delete newItem[field];
        }
      });

      return newItem;
    });

    return cleanedItems;
  };

  const onSubmit = async (val) => {
    const vErrors = getValidationErrorMessages();
    if (vErrors.length > 0) {
      vErrors.forEach((err) => {
        api.error({
          message: "Validation Error",
          description: err,
          placement: "top",
        });
      });
      return;
    }

    if (experienceLevel === "experienced") {
      const missingToDateRow = tableData.find((record, index) => {
        const rowValue = output?.[record.label];
        const isCurrentEmployment =
          index === 0 && rowValue?.currently_working_here === true;

        return !isCurrentEmployment && !rowValue?.to_date;
      });

      if (missingToDateRow) {
        api.error({
          message: "To Date is required for non-current employment entries.",
          placement: "top",
        });
        return;
      }
    }

    if (responseData?.final_submit) {
      const enabledHandlers = [];

      if (disabledIdCardsDetail === false) {
        enabledHandlers.push(() =>
          handleSubmittingFun(() => submitIdentityDetail(val)),
        );
      }

      if (disabledEmployeeHistory === false) {
        enabledHandlers.push(() =>
          handleSubmittingFun(() =>
            submitHistoryApi(getEmploymentHistoryPayload()),
          ),
        );
      }

      if (disabledReferenceDetail === false || relativeLocked === false) {
        enabledHandlers.push(() =>
          handleSubmittingFun(() =>
            submitRefferenceApi(
              Object.values(reffrenceOutput),
              hasRelative === true,
              Object.values(relativeOutput || {}),
            ),
          ),
        );
      }

      if (disabledEsicDetail === false) {
        enabledHandlers.push(() =>
          handleSubmittingFun(() => submitEsicDetailApi(val)),
        );
      }

      if (disabledPfDetail === false) {
        enabledHandlers.push(() =>
          handleSubmittingFun(() => submitPfDetailApi(val)),
        );
      }

      if (enabledHandlers.length === 1) {
        const success = await enabledHandlers[0]();
        if (success) {
          navigate("/new-user/bank-details");
          handleSubmitFinal();
        }
        return;
      }

      for (const handler of enabledHandlers) {
        const success = await handler();
        if (!success) return;
      }

      navigate("/new-user/bank-details");
      handleSubmitFinal();
      return;
    }

    const isIdentitySuccess = await handleSubmittingFun(() =>
      submitIdentityDetail(val),
    );
    if (!isIdentitySuccess) return;
    const isEmployeeHistory = await handleSubmittingFun(() =>
      submitHistoryApi(getEmploymentHistoryPayload()),
    );
    if (!isEmployeeHistory) return;

    const isReference = await handleSubmittingFun(() =>
      submitRefferenceApi(
        Object.values(reffrenceOutput),
        hasRelative === true,
        Object.values(relativeOutput || {}),
      ),
    );
    if (!isReference) return;

    const isEsicDetail = await handleSubmittingFun(() =>
      submitEsicDetailApi(val),
    );
    if (!isEsicDetail) return;

    const isPfDetail = await handleSubmittingFun(() => submitPfDetailApi(val));

    if (isPfDetail) {
      // console.log(responseData?.final_submit);
      if (responseData?.final_submit) {
        handleSubmitFinal();
      } else {
        navigate("/new-user/bank-details");
      }
    }
  };

  const handleSubmitFinal = async () => {
    const { data } = await axios.post("/api/employees/final-submit", {
      final_submit: true,
      sections: [
        "id_cards",
        "employment_history",
        "reference_details",
        "job_details",
        "esic_details",
        "pf_details",
      ],
    });

    if (data?.success) {
      api.success({
        message: data?.message,
        placement: "top",
      });
      navigate("/new-user/bank-details");
    } else {
      api.error({
        message: data?.message,
        placement: "top",
      });
    }

    console.log("hellow");
  };

  const getHistoryValues = (responseData) => {
    const values = {};
    const profile = profileData || {};
    const historyData = responseData?.employment_history;
    const list = Array.isArray(historyData) ? historyData : [];

    list.forEach((item, index) => {
      const rowLabel = index + 1;
      const profileItem = profile?.employment_history?.[index] || {};
      const mergedItem = { ...item, ...profileItem };

      if (index === 0 && mergedItem.to_date === null) {
        mergedItem.currently_working_here = true;
      }

      Object.entries(mergedItem).forEach(([key, val]) => {
        if (key === "documents" && val && typeof val === "object") {
          // Flatten document keys (salary_slip, offer_letter, etc.)
          Object.entries(val).forEach(([docKey, docVal]) => {
            values[`${docKey}_${rowLabel}`] = docVal;
          });
        } else {
          values[`${key}_${rowLabel}`] = val;
        }
      });
    });
    return values;
  };

  const getRefferenceValues = (responseData) => {
    const values = {};
    const profile = profileData || {};
    const list = responseData?.reference_details || [];

    list.forEach((item, index) => {
      const rowLabel = index + 1;
      const profileItem = profile?.reference_details?.[index] || {};
      const mergedItem = { ...item, ...profileItem };

      if (index === 0 && mergedItem.to_date === null) {
        mergedItem.currently_working_here = true;
      }

      Object.entries(mergedItem).forEach(([key, val]) => {
        values[`${key}_${rowLabel}`] = val;
      });
    });
    return values;
  };

  const getAllDetail = async (responseData, additionalValues = {}) => {
    const profile = profileData || {};
    const disableFields = {};

    const getValue = (path) => {
      const profileVal = path.reduce((acc, key) => acc?.[key], profile);
      const responseVal = path.reduce((acc, key) => acc?.[key], responseData);
      const fieldKey = path.join(".");

      if (
        profileVal !== undefined &&
        profileVal !== null &&
        profileVal !== ""
      ) {
        disableFields[fieldKey] = true;
        return profileVal;
      }

      return responseVal;
    };

    const idCardsFields = [
      "aadhar_number",
      "driving_license",
      "pan_number",
      "passport_number",
      "voter_id",
    ];
    const jobDetailsFields = ["employee_type", "location"];
    const esicFields = ["esic_number", "dispensary_address", "is_covered"];
    const pfFields = ["pf_number", "uan_number", "pf_transfer_required"];

    const idCardsValues = {};
    idCardsFields.forEach((key) => {
      const val = getValue(["id_cards", key]);
      if (val !== undefined) idCardsValues[key] = val;
    });

    const jobDetailsValues = {};
    jobDetailsFields.forEach((key) => {
      const val = getValue(["job_details", key]);
      if (val !== undefined) jobDetailsValues[key] = val;
    });

    const esicValues = {};
    esicFields.forEach((key) => {
      const val = getValue(["esic_details", key]);
      if (val !== undefined) esicValues[key] = val;
    });

    const pfValues = {};
    pfFields.forEach((key) => {
      const val = getValue(["pf_details", key]);
      if (val !== undefined) pfValues[key] = val;
    });

    const updatedValues = {
      ...defaultValues,
      ...idCardsValues,
      ...jobDetailsValues,
      ...esicValues,
      ...pfValues,
      employee_id: getValue(["employee_id"]),
      designation: getValue(["designation"]),
      date_of_joining: getValue(["date_of_joining"]),
      department: getValue(["function"]),
      reporting_manager_id: getValue(["reporting_manager", "employee_id"]),
      ...additionalValues,
    };

    setisEsic(responseData?.esic_details?.is_covered);
    setDisabledFields((prev) => ({ ...prev, ...disableFields }));
    reset(updatedValues);
  };

  const getEmployeeDetail = async () => {
    const profile = profileData || {};
    const disableFields = {};

    // 1. Preparation for output states
    const historyData = responseData?.employment_history;
    const historyList = Array.isArray(historyData) ? historyData : [];
    const updatedHistory = {};
    historyList.forEach((item, index) => {
      const profileItem = profile?.employment_history?.[index] || {};
      const mergedItem = { ...item, ...profileItem };

      // Derive 'currently_working_here' if to_date is null for the most recent job
      if (index === 0 && mergedItem.to_date === null) {
        mergedItem.currently_working_here = true;
      }

      updatedHistory[index + 1] = mergedItem;

      if (mergedItem.from_date) {
        disableFields[`employment_history.${index}.from_date`] = true;
      }
      if (mergedItem.to_date) {
        disableFields[`employment_history.${index}.to_date`] = true;
      }
    });
    setOutput(updatedHistory);
    setExperienceLevel(historyList.length > 0 ? "experienced" : "fresher");

    const referenceList = responseData?.reference_details || [];
    const updatedReferences = {};
    referenceList.forEach((item, index) => {
      const profileItem = profile?.reference_details?.[index] || {};
      updatedReferences[index + 1] = { ...item, ...profileItem };

      if (profileItem.from_date) {
        disableFields[`reference_details.${index}.from_date`] = true;
      }
      if (profileItem.to_date) {
        disableFields[`reference_details.${index}.to_date`] = true;
      }
    });
    setRefferenceOutput(updatedReferences);

    const relativeList = responseData?.relative_details || [];
    const updatedRelatives = {};
    relativeList.forEach((item, index) => {
      const profileItem = profile?.relative_details?.[index] || {};
      updatedRelatives[index + 1] = { ...item, ...profileItem };
    });
    setRelativeOutput(updatedRelatives);
    const declaration = responseData?.relative_declaration?.toLowerCase?.();
    if (declaration === "yes" || relativeList.length > 0) {
      setHasRelative(true);
      if (relativeList.length > 0) {
        setRelativeTableData(
          relativeList.map((_, index) => ({ label: index + 1 })),
        );
      }
    } else if (declaration === "no" || referenceList.length > 0) {
      // References were saved earlier without relatives, so the answer was "No"
      setHasRelative(false);
    }

    // 2. Preparation for form values
    const historyValues = getHistoryValues(responseData);
    const referenceValues = getRefferenceValues(responseData);

    setDisabledFields((prev) => ({ ...prev, ...disableFields }));
    getAllDetail(responseData, { ...historyValues, ...referenceValues });
  };

  const shouldDisableFields = (sectionMeta) => {
    if (!sectionMeta) return false;
    return sectionMeta.final_submit === true;
  };

  const {
    pf_details_meta,
    reference_details_meta,
    esic_details_meta,
    employment_history_meta,
    id_cards_meta,
  } = responseData?.final_submit || {};
  const is_Final_submit =
    pf_details_meta?.final_submit === true &&
    reference_details_meta?.final_submit === true &&
    employment_history_meta?.final_submit === true &&
    id_cards_meta?.final_submit === true &&
    esic_details_meta?.final_submit === true;

  const type = localStorage.getItem("userType");
  const lobStr = (
    responseData?.lob ||
    responseData?.line_of_business ||
    responseData?.sub_vertical ||
    responseData?.business_unit ||
    ""
  )?.toLowerCase() || "";
  // Driving License is mandatory only for the JLG LOB.
  const isJlgLob = lobStr.trim() === "jlg";
  const disabledIdCardsDetail = shouldDisableFields(id_cards_meta);
  const disabledEmployeeHistory = shouldDisableFields(employment_history_meta);
  const disabledReferenceDetail = shouldDisableFields(reference_details_meta);
  const disabledEsicDetail = shouldDisableFields(esic_details_meta);
  const disabledPfDetail = shouldDisableFields(pf_details_meta);

  const isFieldDisabled = (fieldName, sectionLocked) => {
    if (disableFields[fieldName]) return true;
    if (!sectionLocked) return false;

    const isFlagged = responseData?.flagged_fields?.some(
      (f) => f.id === fieldName
    );
    return !isFlagged;
  };

  // Relative declaration is newer than the reference section, so it stays
  // editable until relatives have actually been saved.
  const relativeLocked =
    isFieldDisabled("relative_details", disabledReferenceDetail) &&
    (responseData?.relative_details?.length || 0) > 0;

  const allFormValues = watch();

  const getValidationErrorMessages = () => {
    const errors = [];
    if (!experienceLevel) {
      errors.push("• Experience Level is required");
    }

    if (allFormValues.is_covered === true) {
      if (!allFormValues.esic_number) errors.push("• ESIC Number is required when covered");
      if (!allFormValues.dispensary_address) errors.push("• ESIC Dispensary Address is required when covered");
    }

    // CV, Gold, and LAP do not require a Driving License.
    if (isJlgLob && !allFormValues.driving_license) {
      errors.push("• Driving License is required for JLG");
    }

    if (hasRelative === null) {
      errors.push("• Please answer the Relative Declaration (Yes / No)");
    } else if (hasRelative === true) {
      const relatives = relativeTableData.map(
        (row) => relativeOutput?.[row.label] || {},
      );
      if (relatives.some((item) => !item.relationship || !item.employee_code)) {
        errors.push("• Please select Relationship and Employee Code for every relative");
      }
    }

    if (experienceLevel === "experienced") {
      if (!allFormValues.uan_number) {
        errors.push("• UAN Number is required for experienced candidates");
      }
      if (!output || Object.keys(output).length === 0) {
        errors.push("• At least one Employment History entry is required for experienced candidates");
      } else {
        for (const history of Object.values(output)) {
          if (!history.organization_name || !history.designation || !history.from_date || (!history.to_date && history.currently_working_here !== true)) {
            errors.push("• Please fill all mandatory details in Employment History (Organization, Designation, From Date, To Date/Currently Working)");
            break;
          }
        }
      }
    }

    return errors;
  };

  const isAllFieldsValid = () => {
    return getValidationErrorMessages().length === 0;
  };

  useEffect(() => {
    if (responseData) {
      getEmployeeDetail();
    }
  }, [reset, responseData, profileData]);

  useEffect(() => {
    GetActiveEmployeesApi()
      .then((res) => {
        const employees = res.data?.data || [];
        setEmployeeOptions(
          employees
            .filter(
              (emp) =>
                emp.employee_id &&
                !EXCLUDED_RELATIVE_EMPLOYEES.includes(
                  emp.employee_id.toUpperCase(),
                ),
            )
            .map((emp) => ({
              value: emp.employee_id,
              label: employeeLabel(emp),
            })),
        );
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (experienceLevel === "fresher") {
      setTableData(defaultRelations);
      setOutput(null);
    }
  }, [experienceLevel]);

  return (
    <>
      {contextHolder}
      <h3 className="color-heading mb-4">Employment & Identity</h3>

      <form className="h-full" onSubmit={handleSubmit(onSubmit, onerror)}>
        <div className=" border rounded-xl bg-white shadow-md">
          <div
            className="flex justify-between items-center px-4 py-3 border rounded-t-xl cursor-pointer"
            onClick={() => toggleAccordion(0)}
          >
            <h3 className="color-heading2">IDENTITY DETAILS</h3>

            <MdKeyboardArrowDown
              size={35}
              className={`transition-transform duration-300 ${activeIndex === 0 ? "rotate-180" : ""
                }`}
            />
          </div>
          {activeIndex === 0 && (
            <div className={`transition-all duration-300 overflow-hidden p-4`}>
              <div className="flex flex-wrap">
                {/* <Text4
              control={control}
              errors={errors}
              id="aadhar_number"
              disabled={
                disableFields["id_cards.aadhar_number"] ||
                disabledIdCardsDetail ||
                isPanVerified
              }
              name="Aadhar Card Number"
              label="Aadhar Card Number"
              type="number"
              validations={{
                required: false,
                pattern: {
                  value: /^\d{12}$/,
                  message: "Aadhar number must be exactly 12 digits",
                },
              }}
              maxLength={12}
            /> */}
                {/* 
            <Text4
              control={control}
              errors={errors}
              id="pan_number"
              disabled={
                disableFields["id_cards.pan_number"] ||
                disabledIdCardsDetail ||
                isPanVerified
              }
              name="Pan Card Number"
              label="PAN Card Number"
              validations={{
                required: false,
                pattern: {
                  value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                  message: "Invalid PAN format (e.g., ABCDE1234F)",
                },
              }}
              maxLength={10}
            /> */}
                <Text4
                  control={control}
                  errors={errors}
                  id="voter_id"
                  name="Voter Id Number"
                  label="Voter ID Number"
                  disabled={isFieldDisabled("voter_id", disabledIdCardsDetail)}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="passport_number"
                  disabled={isFieldDisabled(
                    "passport_number",
                    disabledIdCardsDetail,
                  )}
                  name="Passport Number"
                  label="Passport Number"
                  example="Example: A1234567"
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="driving_license"
                  name="Driving License"
                  label="Driving License"
                  disabled={isFieldDisabled(
                    "driving_license",
                    disabledIdCardsDetail,
                  )}
                  validations={{
                    required: isJlgLob
                      ? "Driving License is required"
                      : false,
                  }}
                />
              </div>
            </div>
          )}
        </div>

        <div className=" border rounded-xl bg-white shadow-md mt-5">
          <div
            className="flex justify-between items-center px-4 py-3 border rounded-t-xl cursor-pointer"
            onClick={() => toggleAccordion(1)}
          >
            <h3 className="color-heading2">EMPLOYMENT DETAILS</h3>

            <MdKeyboardArrowDown
              size={35}
              className={`transition-transform duration-300 ${activeIndex === 1 ? "rotate-180" : ""
                }`}
            />
          </div>
          {activeIndex === 1 && (
            <>
              <div
                className={`transition-all duration-300 overflow-hidden p-4`}
              >
                <div className="border rounded-xl p-5 bg-gray-50">
                  <p className="text-sm font-medium mb-3">
                    Experience Level <span className="text-red-500">*</span>
                  </p>

                  <div className="grid grid-cols-2 gap-4">
                    {/* Fresher */}
                    <div
                      className={`flex items-center justify-between border rounded-lg px-4 py-3 cursor-pointer transition ${experienceLevel === "fresher"
                        ? "border-blue-500 bg-blue-50"
                        : "border-gray-300 bg-white"
                        }`}
                      onClick={() => setExperienceLevel("fresher")}
                    >
                      <div className="flex items-center gap-2">
                        <input
                          type="radio"
                          checked={experienceLevel === "fresher"}
                          onChange={() => setExperienceLevel("fresher")}
                        />
                        <span className="font-medium">Fresher</span>
                      </div>

                      {/* Icon */}
                      <div className="bg-blue-100 text-blue-600 p-2 rounded-md">
                        🎓
                      </div>
                    </div>

                    {/* Experienced */}
                    <div
                      className={`flex items-center justify-between border rounded-lg px-4 py-3 cursor-pointer transition ${experienceLevel === "experienced"
                        ? "border-blue-500 bg-blue-50"
                        : "border-gray-300 bg-white"
                        }`}
                      onClick={() => setExperienceLevel("experienced")}
                    >
                      <div className="flex items-center gap-2">
                        <input
                          type="radio"
                          checked={experienceLevel === "experienced"}
                          onChange={() => setExperienceLevel("experienced")}
                        />
                        <span className="font-medium">Experienced</span>
                      </div>

                      {/* Icon */}
                      <div className="bg-blue-100 text-blue-600 p-2 rounded-md">
                        💼
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {experienceLevel === "experienced" && (
                <>
                  <div className=" w-full mb-4 px-4">
                    <CustomEditableCard
                      control={control}
                      handleAddRow={handleAddRow}
                      handleRemoveRow={handleRemoveRow}
                      columnsConfig={columnsConfig}
                      additionalColumnsConfig={additionalColumnsConfig}
                      documentColumnsConfig={documentColumnsConfig}
                      tableData={tableData}
                      setTableData={setTableData}
                      output={output}
                      setOutput={setOutput}
                      errors={errors}
                      isLoading={isLoading}
                      allDisabled={disabledEmployeeHistory}
                      flaggedFields={responseData?.flagged_fields}
                      rowAccordion={true}
                      rowTitle={(record, index) =>
                        index === 0
                          ? `Employment #${index + 1} (Most Recent Employment)`
                          : `Employment #${index + 1}`
                      }
                    />
                  </div>
                </>
              )}
            </>
          )}
        </div>

        <div className=" border rounded-xl bg-white shadow-md mt-5">
          <div
            className="flex justify-between items-center px-4 py-3 border rounded-t-xl cursor-pointer"
            onClick={() => toggleAccordion(2)}
          >
            <h3 className="color-heading2">REFERENCE DETAILS</h3>

            <MdKeyboardArrowDown
              size={35}
              className={`transition-transform duration-300 ${activeIndex === 2 ? "rotate-180" : ""
                }`}
            />
          </div>
          {activeIndex === 2 && (
            <div className={`transition-all duration-300 overflow-hidden p-4`}>
              <div className=" w-full mb-4 px-2">
                <CustomEditableCard
                  control={control}
                  columnsConfig={ReferenceColumn}
                  handleAddRow={handleAddRow2}
                  handleRemoveRow={handleRemoveRow2}
                  tableData={tableData2}
                  output={reffrenceOutput}
                  setTableData={setTableData2}
                  setOutput={setRefferenceOutput}
                  isLoading={isLoading}
                  allDisabled={disabledReferenceDetail}
                  flaggedFields={responseData?.flagged_fields}
                  rowTitle={(record, index) => `Reference #${index + 1}`}
                  footer={
                    <div className="rounded-xl bg-blue-50 px-5 py-4 mb-4">
                      <p className="text-base font-semibold text-blue-500 mb-2">
                        Relative Declaration{" "}
                        <span className="text-red-500">*</span>
                      </p>
                      <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
                        <span className="text-sm text-slate-700">
                          Do you have any relatives working in the
                          organization?
                        </span>
                        <Radio.Group
                          value={hasRelative}
                          disabled={relativeLocked}
                          onChange={(e) => setHasRelative(e.target.value)}
                        >
                          <Radio value={true} className="mr-6">
                            Yes
                          </Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </div>

                      {hasRelative === true && (
                        <>
                          {relativeTableData.map((record, index) => (
                            <div
                              key={record.label}
                              className="rounded-xl border border-slate-100 bg-white mt-4 px-3 pt-3"
                            >
                              <div className="flex items-center justify-between px-3">
                                <p className="text-sm font-semibold text-slate-700 m-0">
                                  Relative Details
                                  {relativeTableData.length > 1
                                    ? ` #${index + 1}`
                                    : ""}
                                </p>
                                {relativeTableData.length > 1 &&
                                  !relativeLocked && (
                                    <span
                                      className="text-red-500 cursor-pointer"
                                      onClick={() =>
                                        handleRemoveRelativeRow(record.label)
                                      }
                                    >
                                      <Trash2Icon size={18} />
                                    </span>
                                  )}
                              </div>
                              <Row className="align-content-start w-full">
                                <Select4
                                  id={`relative_relationship_${record.label}`}
                                  name="Relationship"
                                  lg={8}
                                  control={control}
                                  options={relationshipdrop}
                                  validations={{ required: true }}
                                  value={
                                    relativeOutput?.[record.label]?.relationship
                                  }
                                  disabled={relativeLocked}
                                  onChange={(val) =>
                                    handleChangeRelative(
                                      val,
                                      "relationship",
                                      record.label,
                                    )
                                  }
                                />
                                <Select4
                                  id={`relative_employee_code_${record.label}`}
                                  name="Employee Code"
                                  lg={8}
                                  control={control}
                                  options={employeeOptions}
                                  showSearch
                                  validations={{ required: true }}
                                  value={
                                    relativeOutput?.[record.label]?.employee_code
                                  }
                                  disabled={relativeLocked}
                                  onChange={(val) =>
                                    handleChangeRelative(
                                      val,
                                      "employee_code",
                                      record.label,
                                    )
                                  }
                                />
                              </Row>
                            </div>
                          ))}
                          {!relativeLocked && (
                            <button
                              type="button"
                              className="text-blue-500 text-sm font-medium mt-3"
                              onClick={handleAddRelativeRow}
                            >
                              + Add Relative
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  }
                />
              </div>
            </div>
          )}
        </div>

        <div className=" border rounded-xl bg-white shadow-md mt-5">
          <div
            className="flex justify-between items-center px-4 py-3 border rounded-t-xl cursor-pointer"
            onClick={() => toggleAccordion(3)}
          >
            <h3 className="color-heading2">UAN & ESIC DETAILS</h3>

            <MdKeyboardArrowDown
              size={35}
              className={`transition-transform duration-300 ${activeIndex === 3 ? "rotate-180" : ""
                }`}
            />
          </div>
          {activeIndex === 3 && (
            <div className={`transition-all duration-300 overflow-hidden p-4`}>
              <div className=" w-full mb-4 px-2">
                <p className="text-sm">Is the employee covered under ESIC?</p>
                <div style={{ display: "flex", gap: 20, marginBottom: 12 }}>
                  <Controller
                    control={control}
                    name="is_covered"
                    render={({ field }) => {
                      const disable = isFieldDisabled(
                        "esic_details.is_covered",
                        disabledEsicDetail,
                      );
                      return (
                        <>
                          <Checkbox
                            checked={field.value === true}
                            onChange={(e) => {
                              field.onChange(e.target.checked ? true : false);
                              setisEsic(true);
                            }}
                            disabled={disable}
                          >
                            Yes
                          </Checkbox>
                          <Checkbox
                            checked={field.value === false}
                            onChange={(e) => {
                              field.onChange(e.target.checked ? false : null);
                              setisEsic(false);
                            }}
                            disabled={disable}
                          >
                            No
                          </Checkbox>
                        </>
                      );
                    }}
                  />
                </div>
                {isEsic && (
                  <div className="flex mt-2 flex-wrap">
                    <Text4
                      control={control}
                      errors={errors}
                      id="esic_number"
                      name="Esic Number"
                      label="ESIC Number"
                      disabled={isFieldDisabled(
                        "esic_details.esic_number",
                        disabledEsicDetail,
                      )}
                    />

                    <Text4
                      control={control}
                      errors={errors}
                      id="dispensary_address"
                      name="Esic Address"
                      disabled={isFieldDisabled(
                        "esic_details.dispensary_address",
                        disabledEsicDetail,
                      )}
                      label="ESIC Address"
                    />
                  </div>
                )}
                <div className="flex mt-2 flex-wrap">
                  <Text4
                    control={control}
                    errors={errors}
                    id="uan_number"
                    name="UAN Number"
                    disabled={isFieldDisabled("pf_details.uan_number", disabledPfDetail)}
                    label="UAN Number"
                    validations={{
                      required:
                        experienceLevel === "experienced"
                          ? "UAN Number is required"
                          : false,
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        <Row className="step-buttons-box justify-end pt-3 px-2" style={{ borderTop: '1px solid #e5e7eb' }}>
          <button
            type="button"
            className="my-2 step-button back-button mr-2"
            style={{ backgroundColor: "#FFFFFF", color: "#A4A4A4", border: "1px solid #A4A4A4" }}
            onClick={() => {
              navigate(-1);
            }}
          >
            Back
          </button>
          <button
            type="submit"
            className="my-2 text-white step-button"
            disabled={
              (is_Final_submit && !responseData?.flagged_fields?.length) ||
              isLoading
            }
          >
            {isLoading ? "Processing...." : "Save & Continue"}
          </button>
        </Row>
      </form>
    </>
  );
}
